import type { PropsWithChildren } from "react";
import { ActorDatabaseContext } from "#actor-database-context";
import { useActorDatabaseContextValue } from "#actor-database-context-value";

export function ActorDatabaseContextProvider({ children }: PropsWithChildren) {
  const value = useActorDatabaseContextValue();
  return <ActorDatabaseContext.Provider value={value}>{children}</ActorDatabaseContext.Provider>;
}
